<div [ngClass]="{ 'display-flex': avatar }">
  <ng-container *ngIf="avatar">
    <ion-avatar slot="start" class="upload-attachment__avatar">
      <ion-label *ngIf="!attachment">
        <app-avatar [user]="user"> </app-avatar>
      </ion-label>
      <ion-img
        *ngIf="attachment"
        [src]="
          attachment?.thumbnail ? attachment?.thumbnail : attachment?.filePath
        "
        class="upload-attachment__avatar-container"
      ></ion-img>
    </ion-avatar>
    <ion-icon
      *ngIf="!readonly && attachment"
      class="btn"
      name="close"
      (click)="removeAttachement(0)"
      slot="end"
      size="large"
    >
    </ion-icon>
  </ng-container>

  <ion-item
    *ngIf="!readonly"
    class="input"
    lines="none"
    [ngClass]="{ 'upload-attachment__avatar-button': avatar }"
  >
    <div
      class="upload-attachment__control-display"
      [ngClass]="{ 'upload-attachment__control-display--avatar': avatar }"
      (fileDropped)="fileUpload($event)"
      appDragAndDrop
      *ngIf="canAdd(); else noInputs"
    >
      <div
        class="upload-attachment__button-container"
        [ngClass]="{ 'ion-justify-content-end': avatar }"
      >
        <ion-button expand="block" class="upload-attachment__button">
          <label [for]="id" class="upload-attachment__label">
            <ion-icon name="add" slot="start" class="icon-margin"></ion-icon>
            <ng-container *ngIf="!attachment || multiple; else ChangeButton">
              {{
                uploadAttachmentButtonText
                  ? uploadAttachmentButtonText
                  : ('ATTACHMENT_SELECT.SELECT_IMAGE' | translate)
              }}
            </ng-container>
            <ng-template #ChangeButton>
              <span>
                {{
                  changeAttachmentButtonText
                    ? changeAttachmentButtonText
                    : ('ATTACHMENT_SELECT.CHANGE_IMAGE' | translate)
                }}
              </span>
            </ng-template>
          </label>
        </ion-button>

        <ion-button
          *ngIf="p.renderMobile && takePhotoOption"
          expand="block"
          shape="round"
          class="upload-attachment__button"
          (click)="takePicture()"
        >
          <label class="upload-attachment__label">
            <ion-icon name="camera" slot="start" class="icon-margin"></ion-icon>
            <span>
              {{ 'ATTACHMENT_SELECT.TAKE_PHOTO' | translate }}
            </span>
          </label>
        </ion-button>
      </div>

      <div
        *ngIf="!readonly"
        class="ion-text-start text-info"
        [ngClass]="{ 'ion-text-end': avatar }"
      >
        {{ 'ATTACHMENT_SELECT.ATTACHMENT_INFO' | translate }}
        <span *ngIf="multiple">{{
          'ATTACHMENT_SELECT.MAX_PHOTOS' | translate
        }}</span>
        <ng-container *ngIf="!p.renderMobile">
          <br />{{
            'ATTACHMENT_SELECT.ATTACHMENT_DRAG_AND_DROP_INFO' | translate
          }}
        </ng-container>
      </div>
    </div>
    <ng-template #noInputs>
      <ion-label *ngIf="multiple" color="danger" class="font-size__16">
        {{ 'ATTACHMENT_SELECT.MAX_PHOTOS' | translate }}
      </ion-label>
    </ng-template>
  </ion-item>

  <ng-container *ngIf="!avatar">
    <ion-item
      *ngFor="
        let item of multiple
          ? attachment
          : attachment?.filePath
          ? [attachment]
          : [];
        let idx = index
      "
      class="input"
    >
      <ion-img
        [src]="item.filePath ? item.filePath : item.thumbnail"
        class="attachement-img-preview"
        (click)="modalPreview(idx)"
      ></ion-img>

      <ion-icon
        *ngIf="!readonly && attachment"
        class="btn"
        name="close"
        (click)="removeAttachement(idx)"
        slot="end"
        size="large"
      >
      </ion-icon>
    </ion-item>
  </ng-container>
</div>

<input
  #fileInput
  [id]="id"
  class="ion-hide"
  [formControlName]="formControlName"
  type="file"
  (change)="onFileChanged($event)"
  accept="image/x-png,image/gif,image/jpeg"
/>
